import { useEffect } from 'react';
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const TOKEN_SYNC_TS_KEY = 'tokenUpdatedAt';

const TokenRedirect = () => {
    const {tenant,token} = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    
    useEffect(() => {
        if (!tenant || !token) return;

        const currentToken = localStorage.getItem('token');
        if (currentToken !== token) {
            localStorage.setItem('token', token);
            localStorage.setItem(TOKEN_SYNC_TS_KEY, Date.now().toString());
            localStorage.removeItem('user');
            localStorage.removeItem('userCurrentTs');
        }
        const params = new URLSearchParams(location.search);
        const to = params.get('to');
        const menu = params.get('menu');
        if (to === 'settings') {
            navigate(`/${tenant}/settings${menu ? `?menu=${encodeURIComponent(menu)}` : ''}`);
            return;
        }
        navigate(`/${tenant}/dashboard`);
    }, [location.search, navigate, tenant, token]);
    
    return (
        <div className="flex items-center justify-center h-screen">
            <div className="text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
                <p className="text-gray-600">جاري التحويل إلى لوحة التحكم...</p>
            </div>
        </div>
    )

}

export default TokenRedirect
